import {
  getAllContent,
  getContentById,
} from "../../API/content/Content";

// Action types
const GET_ALL_CONTENT_PENDING = "content/getAllContentPending";
const GET_ALL_CONTENT_FULFILLED = "content/getAllContentFulfilled";
const GET_ALL_CONTENT_REJECTED = "content/getAllContentRejected";

const GET_CONTENT_BY_ID_PENDING = "content/getContentByIdPending";
const GET_CONTENT_BY_ID_FULFILLED = "content/getContentByIdFulfilled";
const GET_CONTENT_BY_ID_REJECTED = "content/getContentByIdRejected";

// Action creators
const createAction = (type) => (payload) => ({ type, payload });

const getAllContentPending = createAction(GET_ALL_CONTENT_PENDING);
const getAllContentFulfilled = createAction(GET_ALL_CONTENT_FULFILLED);
const getAllContentRejected = createAction(GET_ALL_CONTENT_REJECTED);

const getContentByIdPending = createAction(GET_CONTENT_BY_ID_PENDING);
const getContentByIdFulfilled = createAction(GET_CONTENT_BY_ID_FULFILLED);
const getContentByIdRejected = createAction(GET_CONTENT_BY_ID_REJECTED);

// Thunks
const createAsyncThunk =
  (action, asyncFunction) => (payload) => async (dispatch) => {
    console.log("createAsyncThunk called with payload:", payload);
    dispatch(action.pending());
    try {
      const response = await asyncFunction(payload);
      console.log("createAsyncThunk response:", response);
      dispatch(action.fulfilled(response));
    } catch (error) {
      console.error("createAsyncThunk error:", error);
      dispatch(action.rejected(error));
    }
  };

export const getAllContentThunk = createAsyncThunk(
  {
    pending: getAllContentPending,
    fulfilled: getAllContentFulfilled,
    rejected: getAllContentRejected,
  },
  getAllContent
);

export const getContentByIdThunk = createAsyncThunk(
  {
    pending: getContentByIdPending,
    fulfilled: getContentByIdFulfilled,
    rejected: getContentByIdRejected,
  },
  getContentById
);

// Reducer
const initialState = {
  content: [],
  selectedContent: null,
  loading: false,
  error: {
    getAllContent: null,
    getContentById: null,
  }
};

const contentReducer = (state = initialState, action) => {
  console.log("contentReducer called with action:", action.type, action.payload);
  
  switch (action.type) {
    case GET_ALL_CONTENT_PENDING:
    case GET_CONTENT_BY_ID_PENDING:
      return { ...state, loading: true, error: null };

    case GET_ALL_CONTENT_FULFILLED:
      return { 
        ...state, 
        content: action.payload.data || [], 
        loading: false, 
        error: null 
      };

    case GET_CONTENT_BY_ID_FULFILLED:
      return { 
        ...state, 
        selectedContent: action.payload.data || null, 
        loading: false, 
        error: null 
      };

    case GET_ALL_CONTENT_REJECTED:
    case GET_CONTENT_BY_ID_REJECTED:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default contentReducer;
